





























































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import SwitchPO from "@/store/entities/devices/switchs/switchpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Common } from "@/lib/Common/Guid";
import Util from "@/lib/util";
@Component({
  components: { TreeSelect },
})
export default class EditSwitch extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  switchpo: SwitchPO = new SwitchPO();
  loading: boolean = false;
  collectorList: any[] = [];
  async created() {
    this.areaTree();
    this.getItemDetail();
    await this.getOrganizations();
    await this.getModelList();
    await this.getCollectorList();
    this.switchpo.isEnable = 1;
  }
  //采集器
  async getCollectorList() {
    await this.$store
      .dispatch("collector/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.collectorList.push({ label: ele.no, value: ele.id })
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //获取组织
  async getOrganizations() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizations = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //获取模型
  async getswitchmodel(val: any) {
    if (val != undefined && val > 0) {
      await this.$store
        .dispatch({ type: "switchmodel/get", id: val })
        .then((ele) => {
          if (ele != null) {
            this.switchpo = ele;
            this.switchpo.modelId = val;
            this.switchpo.id = Common.Guid.MakeNew().ToString();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      detaillist.forEach((ele) => {
        if (ele.itemId == 13) {
          this.$data.transferType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 3) {
          this.$data.ispType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 5) {
          this.$data.potocolType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 17) {
          this.$data.deviceType.push({ label: ele.name, value: ele.id });
        }
      });
    }
  }
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        if (this.switchpo.transferType == 34 && this.switchpo.imei == null) {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: this.L("Imei") + this.L("CanNotBeEmpty"),
            okText: this.L("Yes"),
            cancelText: this.L("No"),
          });
          this.loading = false;
          return;
        }
        await this.$store
          .dispatch({
            type: "switchs/update",
            data: this.switchpo,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.switchpo = Util.extend(true, {}, this.$store.state.switchs.switchItems);
    }
  }
  modelRule = {
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    modelId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    imei: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceNo: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    transferType: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "change",
      },
    ],
    protocol: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    isp: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceTypeId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  //区域
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //获取模型
  async getModelList() {
    this.$data.modelList = [];
    await this.$store
      .dispatch("switchmodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.modelList.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [],
      transferType: [],
      ispType: [],
      potocolType: [],
      modelList: [],
      deviceType: [],
      organizations: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
